import { FLOWS_PAGE_ID } from '_/common/routes/routes.constants';
import { IProjectRouteParams } from '_/common/routes/routes.types';
import { IGetFlowUrlParams } from '_/features/flows/common/utils/flowUtils.types';
import { getProjectUrl } from '_/features/projects/common/utils/projectUrl.utils';

export const getFlowsBaseUrl = (params: IProjectRouteParams): string => `${getProjectUrl(params)}/${FLOWS_PAGE_ID}`;

export const getFlowUrl = (params: IGetFlowUrlParams): string => {
  const { flowSlug, suffix = '' } = params;
  return `${getFlowsBaseUrl(params)}/${flowSlug}${suffix}`;
};
